import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, ButtonBase, useMediaQuery } from "@mui/material";
import ProfileSection from "./ProfileSection";
import { IconMenu2 } from "@tabler/icons";
import LogoSection from "../LogoSection";
import HeaderTabSection from "./HeaderTabSection";
import { filterMenuItems } from "utils/menufilter";
import { useSelector } from "react-redux";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const maxWidth1199 = useMediaQuery("(max-width:1199px)");
  const { authState } = useSelector((state) => state.auth);
  return (
    <>
      <Box
        sx={{
          width: 200,
          display: "flex",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <Box
          component="span"
          sx={{
            display: maxWidth1199 ? "block" : "none",
            flexGrow: 1,
            mr: "20px",
          }}
        >
          <ButtonBase sx={{ borderRadius: "12px", overflow: "hidden" }}>
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: "all .2s ease-in-out",
                background: "white",
                color: "#27797E",
                "&:hover": {
                  background: "#27797E",

                  color: "white",
                },
              }}
              onClick={handleLeftDrawerToggle}
              color="#27797E"
            >
              <IconMenu2 stroke={1.5} size="1.3rem" />
            </Avatar>
          </ButtonBase>
        </Box>
        <Box component="span" sx={{ display: { xs: "block" }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
      </Box>
      {/* Tabs */}
      <Box sx={{ display: maxWidth1199 ? "none" : "flex" }}>
        <HeaderTabSection menuItems={filterMenuItems(authState)} />
      </Box>
      {/* header search */}
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      <ProfileSection />
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
};

export default Header;
